import React, { type ComponentType } from 'react';
import '@atlaskit/css-reset';
import { JiraHoldoutCustomData } from '@atlassian/holdout-utils';
import PageAppInitialisationAnalytics from '@atlassian/jira-common-analytics-page-app-initialisation/src/index.tsx';
import QueryParamAdapter from '@atlassian/jira-dashboards-query-param-adapter/src/index.tsx';
import { FavoriteChangeConsumer } from '@atlassian/jira-favourite-change-provider/src/view/FavoriteChangeConsumer.tsx';
import { withSuspense } from '@atlassian/jira-platform-resources-utils/src/utils/with-suspense/index.tsx';
import { dashboardsDirectoryResource } from '@atlassian/jira-router-resources-directories-dashboards/src/services/dashboards-directory/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { withRouter, type RouteContext, useResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import Dashboards from './view/index.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Props = RouteContext;

// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
const useDashboardsDirectoryResource = withSuspense(() => useResource(dashboardsDirectoryResource));

export const DashboardsDirectory = ({ location }: Props): React.JSX.Element => {
	const state = useDashboardsDirectoryResource();
	const tenantContext = useTenantContext();

	return (
		<QueryParamAdapter location={location}>
			{({ query, onQueryChanged }) => (
				<FavoriteChangeConsumer>
					{(favoriteChangeContext) => (
						<UFOSegment name="dashboards-directory">
							{fg('keystone-jira-bar-holdout-ufo') && <JiraHoldoutCustomData />}
							<Dashboards
								tenantContext={tenantContext}
								prefetchResult={{ ...state }}
								favoriteChangeContext={favoriteChangeContext}
								query={query}
								onQueryChanged={onQueryChanged}
							/>
						</UFOSegment>
					)}
				</FavoriteChangeConsumer>
			)}
		</QueryParamAdapter>
	);
};

// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RouterWrapper: ComponentType<Record<any, any>> = withRouter(DashboardsDirectory);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DashboardsDirectoryType = (props: Record<any, any>): React.JSX.Element => (
	<>
		<MarkProductStart />
		<PageAppInitialisationAnalytics
			appNameSuffixForV2Event="directory.dashboards"
			appNameForV3OperationalEvent="dashboardsDirectory"
		/>
		<RouterWrapper {...props} />
	</>
);

export default DashboardsDirectoryType;
